"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const bourne_1 = require("@hapi/bourne");
exports.parse = (json) => bourne_1.parse(json);
//# sourceMappingURL=parse.js.map